import EditorWrapper from "components/shared/SmsEditorWrapper";
import { AddFollowup, FollowupsWrapper } from "components/shared/SmsFollowupsComponents";
import Text from "components/texts/Text";
import React from "react";
import { useFormState } from "react-final-form";

function CreateEditLightbox() {
  const { values } = useFormState();
  const { followups, FOLLOWUPS_LIMIT, actions } = values;
  const { addFollowup } = actions;

  const Separator = React.memo((p) => <div style={{ marginTop: p.margin || 16 }} />);
  const showAddFollowup = followups.length < FOLLOWUPS_LIMIT;

  return (
    <div>
      <Text size={18}>Compose Your Message</Text>
      <Separator />
      <EditorWrapper name="message" />
      {Boolean(followups.length) && (
        <>
          <Separator margin={32} />
          <FollowupsWrapper settingsName="lightboxSendSettings">
            {followups.map((followup, i) => (
              <EditorWrapper key={followup.id} name={`followups[${i}]`} />
            ))}
          </FollowupsWrapper>
        </>
      )}
      {showAddFollowup && <AddFollowup onClick={addFollowup} />}
    </div>
  );
}

export default React.memo(CreateEditLightbox);
